import { palette } from "./palette"

export interface ResponsiveValueData {
  default: string
  sm: string
  md: string
  lg: string
  xl: string
  "2xl": string
}

export function responsiveFlexDirectionVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.flex)
}

export function responsiveFlexWrapVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.flexWrap)
}

export function responsiveDisplayVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.display)
}

export function responsivePositionVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.position)
}

export function responsiveOverflowVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.overflow)
}

export function responsiveWidthVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.w)
}

export function responsiveMaxWidthVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["max-w"])
}

export function responsiveMinWidthVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["min-w"])
}

export function responsiveHeightVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.h)
}

export function responsiveMaxHeightVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["max-h"])
}

export function responsiveMinHeightVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["min-h"])
}

export function responsiveAspectVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.aspect)
}

export function responsiveObjectFitVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.objectFit)
}

export function responsiveGapXVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["gap-x"])
}

export function responsiveGapYVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["gap-y"])
}

export function responsiveGridColsVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["grid-cols"])
}

export function responsiveGridRowsVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["grid-rows"])
}

export function responsiveGridColSpanVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["col"])
}

export function responsiveGridRowSpanVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["row"])
}

export function responsiveMlVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.ml)
}

export function responsiveMrVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.mr)
}

export function responsiveMtVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.mt)
}

export function responsiveMbVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.mb)
}

export function responsivePlVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.pl)
}

export function responsivePrVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.pr)
}

export function responsivePtVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.pt)
}

export function responsivePbVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.pb)
}

export function responsiveOffsetLeftVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.left)
}

export function responsiveOpacityVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.opacity)
}

export function responsiveRoundedVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.rounded)
}

export function responsiveOffsetRightVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.right)
}

export function responsiveOffsetTopVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.top)
}

export function responsiveOffsetBottomVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.bottom)
}

export function responsiveJustifyContentVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.justify)
}

export function responsiveJustifyItemsVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["justify-items"])
}

export function responsiveJustifySelfVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette["justify-self"])
}

export function responsiveAlignContentVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.content)
}

export function responsiveAlignItemsVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.items)
}

export function responsiveAlignSelfVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.self)
}

export function responsiveBgColorVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.bg)
}

export function responsiveTextColorVariants(valueData: ResponsiveValueData) {
  // console.log("responsiveTextColorVariants", valueData)
  return generateEffectiveResponsiveClasses(valueData, palette.text)
}

export function responsiveTextSizeVariants(valueData: ResponsiveValueData) {
  // console.log("responsiveTextColorVariants", valueData)
  return generateEffectiveResponsiveClasses(valueData, palette.textSizes)
}

export function responsiveTextAlignmentVariants(valueData: ResponsiveValueData) {
  // console.log("responsiveTextColorVariants", valueData)
  return generateEffectiveResponsiveClasses(valueData, palette.textAlignments)
}

export function responsiveBorderSizeVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.borderSize)
}

export function responsiveBorderColorVariants(valueData: ResponsiveValueData) {
  return generateEffectiveResponsiveClasses(valueData, palette.border)
}

// This function uses the value in valueData and produces the relevant effective classes from a palette
// e.g. valueDate= {
//   default: "mt-2"
//   sm: ""
//   md: "mt-4"
//   lg: string
//   xl: "mt-6"
//   "2xl": string
// }
// and palette is the margin palette
// it produces: "mt-2 md:mt-4 xl:mt-6
// Remember one has to do it with the help of a palette, because otherwise tailwind pre processor will eliminate classes in production
// The alternative way of giving
function generateEffectiveResponsiveClasses(valueData: ResponsiveValueData, palette: string) {
  const responsiveClasses: string[] = []
  const mapArbitraryRemToToken = (v: string) => {
    // Map min/max + w/h arbitrary rem to scale tokens (e.g., h-[36rem] -> h-144)
    // Supported: w-[..], h-[..], min-w-[..], max-w-[..], min-h-[..], max-h-[..]
    const m = /^(min-|max-)?(w|h)-\[(\d+)rem\]$/.exec(v)
    if (!m) return v
    const prefix = m[1] ?? ""
    const dim = m[2]
    const rem = Number(m[3])
    if (!Number.isFinite(rem)) return v
    const token = Math.round(rem * 4) // 1rem = 4 spacing units
    return `${prefix}${dim}-${token}`
  }
  const isArbitrary = (v: string) => /\[[^\]]+\]/.test(v)
  if (valueData) {
    for (let property in valueData) {
      if (property === "default") {
        const classValue = mapArbitraryRemToToken(valueData[property])
        if (!classValue) continue
        if (palette.includes(classValue) || isArbitrary(classValue)) {
          responsiveClasses.push(classValue)
        }
      } else {
        const classValue = mapArbitraryRemToToken(valueData[property])
        if (!classValue) continue
        const responsiveClass = property + ":" + classValue
        if (palette.includes(responsiveClass) || isArbitrary(classValue)) {
          responsiveClasses.push(responsiveClass)
        }
      }
    }
  }
  return responsiveClasses.join(" ")
}
